const safeDecode = (value) => {
  try {
    return decodeURIComponent(value);
  } catch (_) {
    return value;
  }
};

export const parseUserPanelPath = (pathname) => {
  const cleanPath = String(pathname || '').split(/[?#]/)[0];
  const pathParts = cleanPath.split('/').filter(Boolean);
  const panelIndex = pathParts.indexOf('user-panel');
  const parts = (panelIndex >= 0 ? pathParts.slice(panelIndex + 1) : []).map(safeDecode);

  if (parts[0] !== 'service-orders') {
    return { sectionId: 'dashboard', serviceOrderId: '' };
  }

  return {
    sectionId: 'service-orders',
    serviceOrderId: parts[1] || '',
  };
};

export const userServiceOrdersPath = () => '/user-panel/service-orders';

export const userServiceOrderDetailPath = (orderId) => (
  orderId
    ? `/user-panel/service-orders/${encodeURIComponent(orderId)}`
    : userServiceOrdersPath()
);
